import I18n from 'I18n';
import { getRecipients, getSenders } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { List as ImmutableList } from 'immutable';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import { HS_EMAIL_ADDRESS, HS_PHONE_NUMBER } from 'conversations-message-history/common-message-format/constants/deliveryIdentifierTypes';
import { getDeliveryIdentifier as getSenderDeliveryIdentifier } from 'conversations-message-history/common-message-format/operators/senderGetters';
import { getSingleDeliveryIdentifier as getRecipientDeliveryIdentifier } from 'conversations-message-history/common-message-format/operators/recipientGetters';
// @ts-expect-error module not typed
import { getDateString } from 'conversations-message-history/util/labelDateUtils';
// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import senderHeaderPopoverTranslationKeys from '../shared/constants/senderHeaderPopoverTranslationKeys';
import { OptionValueType } from './CommonMessageHeaderPopoverList';
import { getDeliveryIdentifierType, getDeliveryIdentifierValue } from 'conversations-message-history/common-message-format/operators/deliveryIdentifierGetters';
import { jsx as _jsx } from "react/jsx-runtime";
const formatDeliveryIdentifiers = (val, deliveryIdentifier) => {
  const deliveryIdentifierType = getDeliveryIdentifierType(deliveryIdentifier);
  const deliveryIdentifierValue = getDeliveryIdentifierValue(deliveryIdentifier);
  if (deliveryIdentifierType === HS_PHONE_NUMBER) {
    val = val.push( /*#__PURE__*/_jsx(FormattedPhoneNumber, {
      value: deliveryIdentifierValue
    }));
  }
  if (deliveryIdentifierType === HS_EMAIL_ADDRESS) {
    val = val.push( /*#__PURE__*/_jsx("span", {
      children: deliveryIdentifierValue
    }));
  }
  return val;
};
const getToValue = ({
  recipients
}) => {
  if (recipients && recipients.size) {
    return recipients.reduce((val, recipient) => {
      const recipientDeliveryIdentifier = getRecipientDeliveryIdentifier(recipient);
      return formatDeliveryIdentifiers(val, recipientDeliveryIdentifier);
    }, ImmutableList());
  }
  return null;
};
const getFromValue = ({
  senders
}) => {
  if (senders && senders.size) {
    return senders.reduce((val, sender) => {
      const senderDeliveryIdentifier = getSenderDeliveryIdentifier(sender);
      if (senderDeliveryIdentifier) {
        return formatDeliveryIdentifiers(val, senderDeliveryIdentifier);
      }
      return val;
    }, ImmutableList());
  }
  return null;
};
export const getCommonMessageHeaderContents = ({
  message
}) => {
  const timestamp = getTimestamp(message);
  const recipients = getRecipients(message);
  const senders = getSenders(message);
  const from = getFromValue({
    senders
  });
  const to = getToValue({
    recipients
  });
  let baseOptions = ImmutableList();
  if (to && to.size) {
    baseOptions = baseOptions.push({
      key: senderHeaderPopoverTranslationKeys.TO,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.popover.to"
      }),
      data: {
        value: to,
        valueType: OptionValueType.List
      }
    });
  }
  if (from && from.size) {
    baseOptions = baseOptions.push({
      key: senderHeaderPopoverTranslationKeys.FROM,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.popover.from"
      }),
      data: {
        value: from,
        valueType: OptionValueType.List
      }
    });
  }
  if (baseOptions.size) {
    baseOptions = baseOptions.push({
      key: senderHeaderPopoverTranslationKeys.DATE,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.popover.date"
      }),
      data: {
        value: /*#__PURE__*/_jsx("span", {
          children: getDateString(I18n.moment(timestamp))
        }),
        valueType: OptionValueType.Date
      }
    });
  }
  return baseOptions.toArray();
};